var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAtmosphereIconcomponent = function SvgAtmosphereIconcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 9C6.75 9 4.875 7.125 4.875 4.875S6.75.75 9 .75V9Zm0 0c0-2.25 1.875-4.125 4.125-4.125S17.25 6.75 17.25 9H9Zm0 0v8.25c2.25 0 4.125-1.875 4.125-4.125S11.25 9 9 9Zm0 0c0 2.25-1.875 4.125-4.125 4.125S.75 11.25.75 9H9Z",
    fill: "#CECCC9"
  })));
};
export default SvgAtmosphereIconcomponent;